/**
 * Middleware Object for use with data-fetcher.js. 
 * Create a new instance and provide implementation methods for 
 * manipulating the request, response, and/or return data from a data-fetch.
 * @name Data-transfer-object
 */
define('DataTransferObject/DataTransferObject',['require','exports','module'],function(require,exports,module){
	var FUNCTION='function',
		proto;

	function DataTransferObject(implementation){
		if(!(this instanceof DataTransferObject)){
			return new DataTransferObject(implementation);
		}
		var type;
		for(type in implementation){
			if(type in this && proto.hasOwnProperty(type) && typeof implementation[type]===FUNCTION){
				this[type]=implementation[type];
			}
		}
	};
	proto=DataTransferObject.prototype={
		datasource : function(datasource){},
		request : function(request){return request;},
		response: function(response){return response;},
		data 	: function(data){return data;}
	};

	return DataTransferObject;
});
